import {Props} from './model';
import * as React from 'react';
import {View} from 'react-native';
import {SurveyCongratsMessage} from '../components/surveyCongratsMessage';
import {useStyles} from '../../../shared/hooks/styles';
import Screen from '../../../shared/components/screen';
import {images} from '../../../assets/icons';
import {useTheme} from '../../../shared/theme';

export default ({}: Props) => {
  const theme = useTheme();
  const styles = useStyles(() => ({
    sectionContainer: {
      paddingTop: 100,
      paddingBottom: theme.screen.bottomOffset,
      minHeight: 600,
      paddingHorizontal: 20,
      flex: 1,
      position: 'relative',
      zIndex: 1,
    },
    image: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      color: theme.polls.shapes.color,
    },
    scrollView: {
      flex: 1,
    },
  }));
  return (
    <Screen style={styles.scrollView}>
      <View style={styles.sectionContainer}>
        <SurveyCongratsMessage />
      </View>
      <View style={styles.image}>
        <images.SurveySuccessBg width={360} height={297} color={theme.polls.shapes.color} />
      </View>
    </Screen>
  );
};
